import Alicante from "./bannerImages/Alicante-compress.webp";
import Barcelona from "./bannerImages/Barcelona y Cataluña-compress.webp";
import Bilbao from "./bannerImages/Bilbao y País Vasco-compress.webp";
import Cordoba from "./bannerImages/Córdoba-compress.webp";
import Granada from "./bannerImages/Granada-compress.webp";
import Ibiza from "./bannerImages/Ibiza-compress.webp";
import LaRioja from "./bannerImages/La Rioja-compress.webp";
import Lanzarote from "./bannerImages/Lanzarote-compress.webp";
import LasPalmas from "./bannerImages/Las Palmas de Gran Canaria y Canarias-compress.webp";
import Leon from "./bannerImages/León y Castilla y León-compress.webp";
import Madrid from "./bannerImages/Madrid (Comunidad y ciudad)-compress.webp";
import Menorca from "./bannerImages/Menorca-compress.webp";
import Murcia from "./bannerImages/Murcia-compress.webp";
import Malaga from "./bannerImages/Máñaga-compress.webp";
import Palma from "./bannerImages/Palma de Mallorca y Baleares-compress.webp";
import Pamplona from "./bannerImages/Pamplona y Navarra-compress.webp";
import SanSebastian from "./bannerImages/San Sebastián-compress.webp";
import Santiago from "./bannerImages/Santiago de Compostela y Galicia-compress.webp";
import Segovia from "./bannerImages/Segovia-compress.webp";
import Sevilla from "./bannerImages/Sevilla y Andalucía-compress.webp";
import Tenerife from "./bannerImages/Tenerife-compress.webp";
import Toledo from "./bannerImages/Toledo y Castilla la Mancha-compress.webp";
import Valencia from "./bannerImages/Valencia (ciudad y comunidad)-compress.webp";
import Zaragoza from "./bannerImages/Zaragoza y Aragón-compress.webp";
import cities from "@/components/home/json/cities.json";

export const getBannerImage = (city: string): string => {
  let finded = false;
  let i = 0;
  let parsedCity = city.toLowerCase();
  while (i < cities.length && !finded) {
    if (cities[i].province.toLowerCase() == city.toLowerCase()) {
      parsedCity = cities[i].community.toLowerCase();
      finded = true;
    } else {
      i++;
    }
  }
  switch (parsedCity) {
    case "catalunya":
      return Barcelona.src;
    case "castilla león":
      if (city.toLowerCase() == "segovia") {
        return Segovia.src;
      } else {
        return Leon.src;
      }

    case "galicia":
      return Santiago.src;
    case "murcia":
      return Murcia.src;
    case "valencia":
      if (city.toLowerCase().includes("alicante")) {
        return Alicante.src;
      } else {
        return Valencia.src;
      }
    case "andalucía":
      if (city.toLowerCase() == "málaga") {
        return Malaga.src;
      } else if (city.toLowerCase() == "granada") {
        return Granada.src;
      } else if (city.toLowerCase() == "córdoba") {
        return Cordoba.src;
      } else {
        return Sevilla.src;
      }
    case "aragón":
      return Zaragoza.src;
    case "canarias":
      if (city.toLowerCase() == "las palmas") {
        return LasPalmas.src;
      } else if (city.toLowerCase() == "santa cruz de tenerife") {
        return Tenerife.src;
      } else if (city.toLowerCase() == "lanzarote") {
        return Lanzarote.src;
      } else {
        return LasPalmas.src;
      }
    case "castilla la mancha":
      return Toledo.src;
    case "madrid":
      return Madrid.src;
    case "comunidad de madrid":
      return Madrid.src;
    case "islas baleares":
      if (city.toLowerCase() == "palma de mallorca") {
        return Palma.src;
      } else if (city.toLowerCase() == "ibiza") {
        return Ibiza.src;
      } else if (city.toLowerCase().includes("menorca")) {
        return Menorca.src;
      } else {
        return Palma.src;
      }
    case "la rioja":
      return LaRioja.src;
    case "navarra":
      return Pamplona.src;
    case "país vasco":
      if (city.toLowerCase().includes("sebas")) {
        return SanSebastian.src;
      } else {
        return Bilbao.src;
      }

    default:
      return Barcelona.src;
  }
};
